import { DatePivotParams } from "../../entities/date_pivot_params";

export const paramsToTransformArgs = (
  params: DatePivotParams
): Record<string, string[] | [string, string, string[] | string][] | null> => {
  return {
    // Segments are the full grain, not a drill under location: the transform groups
    // by exactly what is selected and only falls back to location when nothing is.
    // Selecting sku alone therefore gives totals across every site.
    segmentation_fields: params.segments ?? [],
    filters: params.filters,
  };
};
